import { render } from "./ReportThemes.vue?vue&type=template&id=72ab74be"
import script from "./ReportThemes.vue?vue&type=script&lang=js"
export * from "./ReportThemes.vue?vue&type=script&lang=js"

import "./ReportThemes.vue?vue&type=style&index=0&id=72ab74be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__